import script from "./SupportPopper.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportPopper.vue?vue&type=script&setup=true&lang=js"

import "./SupportPopper.vue?vue&type=style&index=0&id=0f57d8da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f57d8da"]])

export default __exports__